import { Component } from "react";
import DIALOGBOX_EVENT_TYPES from "../types/DialogBoxEventTypes";
import {
  IDialogBoxEvent,
  IDialogBoxWaitingEvent,
} from "../types/DialogBoxEvents";

import "../styles/dialogBox.css";
import "../styles/loading.css";
import { Button } from "./buttons/Button";

export default class DialogBox extends Component<
  {
    rawEvent: IDialogBoxEvent;
    type: DIALOGBOX_EVENT_TYPES;
    header?: string;
    message?: string;
    labels?: { yes: string; no: string };
    onClick: Function;
  },
  {}
> {
  constructor(
    props: Readonly<{
      rawEvent: IDialogBoxEvent;
      type: DIALOGBOX_EVENT_TYPES;
      header?: string | undefined;
      message?: string | undefined;
      labels?: { yes: string; no: string } | undefined;
      onClick: Function;
    }>,
  ) {
    super(props);
  }

  componentDidMount() {
    if (this.props.rawEvent.type === "DB_waiting") {
      (this.props.rawEvent as IDialogBoxWaitingEvent).waitingOn
        .then((data: any) => this.props.onClick(data))
        .finally(() => this.props.onClick());
    }
  }

  yesNoButtons() {
    if (this.props.type !== "DB_yesNoQuery") return <></>;

    return (
      <div className={"buttons"}>
        <Button className={"white"} onClick={() => this.props.onClick(false)}>
          {this.props.labels?.no}
        </Button>
        <Button onClick={() => this.props.onClick(true)}>
          {this.props.labels?.yes}
        </Button>
      </div>
    );
  }
  confirmButton() {
    if (this.props.type !== "DB_confirm") return <></>;

    return (
      <div className={"buttons"}>
        <Button autoFocus={true} onClick={() => this.props.onClick()}>
          OK
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div className={"dialogBox"}>
        <div className={"header"}>
          {this.props.header == null ? "Error" : this.props.header}
        </div>
        <div className={"body"}>
          <div className={"message"}>
            <pre>{this.props.message}</pre>
          </div>
          {this.props.rawEvent.type === "DB_waiting" && (
            <progress>
              <span className={"spinner"}></span>
            </progress>
          )}
          {this.yesNoButtons()}
          {this.confirmButton()}
        </div>
      </div>
    );
  }
}
